import { render, staticRenderFns } from "./ActUploads__tax.vue?vue&type=template&id=59050158&scoped=true&"
import script from "./ActUploads__tax.vue?vue&type=script&lang=js&"
export * from "./ActUploads__tax.vue?vue&type=script&lang=js&"
import style0 from "./ActUploads__tax.vue?vue&type=style&index=0&id=59050158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59050158",
  null
  
)

export default component.exports